// extracted by mini-css-extract-plugin
module.exports = {"searchBar":"SearchStickyHeader_searchBar__Zrwc3","search":"SearchStickyHeader_search__3pXtf"};